// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailedSlider_block__E9nS7","title":"DetailedSlider_title__PNdcF","slider":"DetailedSlider_slider__idWgc"};